import React from 'react'
import Preloader from '../../Global/Preloader';
import Headertwo from '../../Global/Headertwo';
import Servicedtlbred from '../Mainservicesdetails/Servicedtlbred';
import Servicesdetails from '../Mainservicesdetails/Servicesdetails';
import Ctaone from '../../Global/Ctaone';
import Footer from '../../Global/Footer';
import BackToTop from '../../Global/BackToTop';

const Main = () => {
    return (
        <>
            {/* <Preloader /> */}
            <Headertwo />
            <Servicedtlbred title="Tour & Travels" />
            {/* <Servicesdetails />
            <Ctaone /> */}
            <Footer />
            <BackToTop/>
        </>
    )
}
export default Main;